window.addEventListener('load', () => {
    let parallax = document.querySelectorAll('.rellax');
    let parallaxSlow2 = document.querySelectorAll('.rellax-slow-2');

    if (parallax.length) {
        let rellax = new Rellax('.rellax', {
            speed: -.5,
        });
    }

    if (parallaxSlow2.length) {
        let rellaxSlow2 = new Rellax('.rellax-slow-2', {
            speed: -.15,
        });
    }
});